var m = require('mithril');
var Promise = require('bluebird');
var moment = require('moment-timezone');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var cardsPagination = require('../../data/components/cardsPagination');
var alarmEventCard = require('./alarmEventCard');

var dateFormat = 'MM-DD-YYYY hh:mm:ss a';

var component = {
  oninit : function (vnode) {
    var ctrl = this;
    ctrl.eventsRids = prop();
    ctrl.location =  prop(vnode.attrs.location);
    ctrl.eventsSortedByStartDate = prop(false); 
    ctrl.eventsSortedByEndDate = prop(false);
    ctrl.searchEventActive = prop(false);
    ctrl.searchEvent = prop('');
    ctrl.eventsToShow = prop([]);
    ctrl.pageNumber = prop(0);
    ctrl.searchEventValue = prop('');
    ctrl.preferredNumberOfRowsValue = prop();
    ctrl.selectedPage = prop();
    ctrl.lastPage = prop(true);
    
    if(window.innerWidth >= 1000) {
      ctrl.preferredNumberOfRowsValue(4)
    }
    if(window.innerWidth < 1000) {
      ctrl.preferredNumberOfRowsValue(3)
    }
    if(window.innerWidth < 750) {
      ctrl.preferredNumberOfRowsValue(2)
    }
    if(window.innerWidth < 550) {
      ctrl.preferredNumberOfRowsValue(1)
    }

    ctrl.init = function (){
      Promise.all([
        loaders.requestWithLoader({
          loader: 'main',
          url: '/api/v1/alarmevents/rids',
          method: 'GET',
          params: {
            locationRid: ctrl.location()['name'] == 'root' ? null : ctrl.location()['@rid'].slice(1)
          }
        }),
        loaders.requestWithLoader({
          loader: 'main',
          url: '/api/v1/alarmevents/paginated',
          method: 'GET',
          params: {
            locationRid: ctrl.location()['name'] == 'root' ? null : ctrl.location()['@rid'].slice(1),
            pageNumber: ctrl.pageNumber(),
            search: ctrl.searchEventValue(),
            preferredNumberOfRowsValue: ctrl.preferredNumberOfRowsValue()
          }
        })
      ])
      .then( data => {
        ctrl.eventsRids(data[0]);
        ctrl.eventsToShow(data[1]);
        ctrl.eventsToShow().forEach(eventRecord => {
          eventRecord.ocurredAt = eventRecord.out_OccurredAt && eventRecord.out_OccurredAt[0].in.name ? eventRecord.out_OccurredAt[0].in.name: '';
        });
        m.redraw();
      })
    }
    
    ctrl.init();

  },
  onupdate: function (vnode) {
    var ctrl = this;
    if(vnode.attrs.location['@rid'] != ctrl.location()['@rid']){
      ctrl.location(vnode.attrs.location);
      ctrl.init();
    }
  },
  view: function (vnode) {
    var ctrl = this;
    if(!ctrl.eventsRids() || ctrl.eventsRids().length == 0) return;
    if(window.innerWidth >= 1000 && ctrl.preferredNumberOfRowsValue() != 4) {
      ctrl.preferredNumberOfRowsValue(4)
    }
    if(window.innerWidth < 1000 && ctrl.preferredNumberOfRowsValue() != 3) {
      ctrl.preferredNumberOfRowsValue(3)
    }
    if(window.innerWidth < 750 && ctrl.preferredNumberOfRowsValue() != 2) {
      ctrl.preferredNumberOfRowsValue(2)
    }
    if(window.innerWidth < 550 && ctrl.preferredNumberOfRowsValue() != 1) {
      ctrl.preferredNumberOfRowsValue(1)
    }
    return m('div.mv3',[
      m(cardsPagination, {
        data: [...ctrl.eventsRids()],
        url: '/api/v1/alarmevents/paginated',
        recordsToShow: ctrl.eventsToShow,
        parameterFieldName: 'pageNumber',
        searchValue: ctrl.searchEventValue,
        preferredNumberOfRowsValue: ctrl.preferredNumberOfRowsValue,
        locationRid: prop(ctrl.location()['name'] == 'root' ? null : ctrl.location()['@rid'].slice(1)),
        selectedPage: ctrl.selectedPage,
        lastPage: ctrl.lastPage
      },[
        ctrl.eventsToShow().map((eventRecord, idx) => {
          return m(alarmEventCard,{
            start: eventRecord.start ? moment(eventRecord.start).format(dateFormat) : '',
            end: eventRecord.end ? moment(eventRecord.end).format(dateFormat) : '',
            eventRecord: eventRecord,
            contextLocation: ctrl.location,
            parentVnode: this,
            preferredNumberOfRowsValue: ctrl.preferredNumberOfRowsValue,
            idx: idx,
            recordsLength: ctrl.eventsToShow().length,
            selectedPage: ctrl.selectedPage,
            lastPage: ctrl.lastPage
          })
        }),
      ])
    ])
  }
};

module.exports = component;
